<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <validation-observer
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(fetchData)">
            <base-material-card
              class="pa-6"
              color="indigo"
              icon="mdi-file-chart"
            >
              <template v-slot:after-heading>
                <div class="display-2 font-weight-light">
                  {{ $t('parameters') }}
                </div>
              </template>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.cashDeskMovements.startDate"
                          >
                            <v-text-field
                              v-model="parameter.startDate"
                              :label="$t('fields.reportParameters.cashDeskMovements.startDate')"
                              hint="YYYY/MM/DD"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="parameter.startDate"
                          no-title
                          :locale="$i18n.locale"
                          @input="startDateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        ref="menuStartTime"
                        v-model="startTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="startTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.cashDeskMovements.startTime"
                          >
                            <v-text-field
                              v-model="startTime"
                              :label="$t('fields.reportParameters.cashDeskMovements.startTime')"
                              prepend-icon="mdi-timer"
                              readonly
                              v-bind="attrs"
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-time-picker
                          v-if="startTimeMenu"
                          v-model="startTime"
                          format="24hr"
                          full-width
                          @click:minute="$refs.menuStartTime.save(startTime)"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.cashDeskMovements.endDate"
                          >
                            <v-text-field
                              v-model="parameter.endDate"
                              :label="$t('fields.reportParameters.cashDeskMovements.endDate')"
                              hint="YYYY/MM/DD"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="parameter.endDate"
                          no-title
                          :locale="$i18n.locale"
                          @input="endDateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        ref="menuEndTime"
                        v-model="endTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="endTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.cashDeskMovements.endTime"
                          >
                            <v-text-field
                              v-model="endTime"
                              :label="$t('fields.reportParameters.cashDeskMovements.endTime')"
                              prepend-icon="mdi-timer"
                              readonly
                              v-bind="attrs"
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-time-picker
                          v-if="endTimeMenu"
                          v-model="endTime"
                          format="24hr"
                          full-width
                          @click:minute="$refs.menuEndTime.save(endTime)"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="reportParameters.cashDeskMovements.cashDeskId"
                  >
                    <v-select
                      v-model="parameter.cashDeskId"
                      :items="cashDesks"
                      item-text="name"
                      item-value="id"
                      :label="$t('fields.reportParameters.cashDeskMovements.cashDeskId')"
                      :error-messages="errors"
                      outlined
                      :loading="loadingcashDesks"
                      @change="getCashDeskItems"
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="parameter.cashDeskItemId"
                    :items="cashDeskItems"
                    item-text="name"
                    item-value="id"
                    :label="$t('fields.reportParameters.cashDeskMovements.cashDeskItemId')"
                    outlined
                    :loading="loadingcashDeskItems"
                  />
                </v-col>
              </v-row>
              <div class="pa-3 text-center">
                <v-btn
                  color="success"
                  default
                  type="submit"
                  :loading="loading"
                >
                  {{ $t("show") }}
                </v-btn>
                <v-btn
                  color="secondary"
                  default
                  type="submit"
                  :loading="loadingExcel"
                  @click="downloadExcel"
                >
                  <v-icon left>
                    mdi-download
                  </v-icon>
                  {{ $t('exportToExcel') }}
                </v-btn>
              </div>
            </base-material-card>
          </form>
        </validation-observer>
      </v-col>
    </v-row>
    <base-material-card
      color="indigo"
      icon="mdi-cash-register"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :sort-by="['registerAt']"
        :sort-desc="[false]"
        :loading="loading"
        :search.sync="search"
        :server-items-length="totalMovements"
        :options.sync="options"
      >
        <template v-slot:item.name="{ item }">
          <router-link :to="{ name: 'cashDesk', params: { id: item.id }}">
            {{ item.name }}
          </router-link>
        </template>
        <template v-slot:item.actions="{ }">
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <base-material-snackbar
        v-model="showErrorMessage"
        type="error"
        v-bind="{
          ['top']: true,
          ['center']: true,
          ['vertical']: true
        }"
      >
        {{ errorMessage }}
      </base-material-snackbar>
    </base-material-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import { exportToExcel } from '@/common/excelExport'
  const cashDesksRespository = repositoryFactory.get('cashDesks')
  const cashDesksRepository = repositoryFactory.get('cashDesks')
  const cashDeskItemsRepository = repositoryFactory.get('cashDeskItems')

  export default {
    name: 'CashDeskMovementList',
    data: () => ({
      startDateMenu: false,
      startTimeMenu: false,
      endTimeMenu: false,
      endDateMenu: false,
      startTime: '00:00',
      endTime: '23:59',
      items: [],
      totalMovements: 0,
      parameter: {
        cashDeskId: '',
        startDate: moment().format('YYYY-MM-DD'), // new Date().toISOString().substr(0, 10),
        endDate: moment().format('YYYY-MM-DD'),
      },
      cashDesks: [],
      cashDeskItems: [],
      options: {},
      search: undefined,
      loading: false,
      loadingcashDesks: false,
      loadingcashDeskItems: false,
      loadingExcel: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('cashDeskMovements')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.cashDeskMovements.registerAt'),
            value: 'registerAt',
          },
          {
            text: this.$t('tables.cashDeskMovements.amount'),
            value: 'amount',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      this.getCashDesks()
    },
    methods: {
      fetchData () {
        var self = this
        self.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        var parameters = Object.assign({}, this.parameter)
        parameters.endDate = moment(`${this.parameter.endDate} ${this.endTime}:00`).format()
        parameters.startDate = moment(`${this.parameter.startDate} ${this.startTime}:00`).format()

        var data = {
          data: parameters,
          page: page,
          pageSize: itemsPerPage,
          sortBy: sortBy,
          sortDesc: sortDesc,
        }

        cashDesksRespository.getMovements(data).then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
            self.totalMovements = response.data.totalRows
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.loading = false
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
        })
      },
      getCashDesks () {
        var self = this
        self.loadingcashDesks = true
        cashDesksRepository.get().then(response => {
          self.cashDesks = response.data.data
          self.loadingcashDesks = false
        }).catch(err => {
          self.loadingcashDesks = false
          alert(err)
        })
      },
      getCashDeskItems () {
        var self = this
        self.loadingcashDeskItems = true
        cashDeskItemsRepository.getByCashDesk(self.parameter.cashDeskId).then(response => {
          self.cashDeskItems = response.data.data
          self.cashDeskItems.splice(0, 0, { id: null, name: '--' })
          self.loadingcashDeskItems = false
        }).catch(err => {
          self.loadingcashDeskItems = false
          alert(err)
        })
      },
      async downloadExcel () {
        this.loadingExcel = true
        var parameters = Object.assign({}, this.parameter)
        parameters.endDate = moment(`${this.parameter.endDate} ${this.endTime}:00`).format()
        parameters.startDate = moment(`${this.parameter.startDate} ${this.startTime}:00`).format()

        var data = {
          data: parameters,
        }
        const response = await cashDesksRespository.getMovements(data)
        const columns = [
          { key: 'registerAt', title: 'Fecha', cell: 'A1' },
          { key: 'amount', title: 'Monto', cell: 'B1' },
        ]
        exportToExcel('Movimientos', columns, response.data.data)
        this.loadingExcel = false
      },
    },
  }
</script>
